import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-invoice-card',
  templateUrl: './app-invoice-card.component.html',
  styleUrls: ['./app-invoice-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppInvoiceCardComponent {
  @Input() invoice: any;
  @Input() index: number = 0;
  @Input() chartId?: string;
  @Input() isExpanded: boolean = false;
  @Input() accessPermission: string = 'SALES_CONTACTS';
  @Input() amountHeading: string = 'PAYABLE AMOUNT';
  @Input() labelPrefix: string = 'Invoice No';
  @Input() showPieChart: boolean = true;
  @Input() showActionMenu: boolean = true;
  @Input() showEditAction: boolean = true;
  @Input() showDeleteAction: boolean = true;
  @Input() isPaymentAllowed: boolean = true;
  @Input() isDownloadPdfAllowed: boolean = true;
  @Input() isCopyPdfAllowed: boolean = true;
  @Input() showCustomerDetails: boolean = true;
  @Input() customClass: string = '';

  @Output() cardClick = new EventEmitter<any>();
  @Output() addPayment = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() downloadPdf = new EventEmitter<any>();
  @Output() copyPdfLink = new EventEmitter<any>();
  @Output() customerDetails = new EventEmitter<any>();

  get pieChartId(): string {
    return this.chartId || `pieChart${this.index}`;
  }

  get contactName(): string {
    return (
      this.invoice?.contact_first_name ||
      this.invoice?.contact_business_name ||
      '-'
    );
  }

  get displayName(): string {
    const name = this.contactName;
    if (name.length > 25) {
      return name.substring(0, 25) + '...';
    }
    return name;
  }

  get invoiceNumberDisplay(): string {
    const num = this.invoice?.iqp_invoice_number || '-';
    if (num.length > 25) {
      return num.substring(0, 25) + '...';
    }
    return num;
  }

  get statusDisplay(): string {
    return this.invoice?.status || this.invoice?.iqp_status || 'Draft';
  }

  get statusBadgeClass(): { [key: string]: boolean } {
    const st = this.statusDisplay;
    return {
      'yet-start': st === 'Draft',
      'on-hold': st === 'Partially paid',
      'yet-progress': st === 'Sent',
      delivered: st === 'Paid',
    };
  }

  onCardClick(event: MouseEvent): void {
    this.cardClick.emit(this.invoice);
  }

  onAddPayment(event: MouseEvent): void {
    event.stopPropagation();
    this.addPayment.emit(this.invoice);
  }

  onEdit(event: MouseEvent): void {
    event.stopPropagation();
    this.edit.emit(this.invoice);
  }

  onDelete(event: MouseEvent): void {
    event.stopPropagation();
    this.delete.emit(this.invoice);
  }

  onDownloadPdf(event: MouseEvent): void {
    event.stopPropagation();
    this.downloadPdf.emit(this.invoice);
  }

  onCopyPdfLink(event: MouseEvent): void {
    event.stopPropagation();
    this.copyPdfLink.emit(this.invoice);
  }

  onCustomerDetails(event: MouseEvent): void {
    event.stopPropagation();
    this.customerDetails.emit(this.invoice);
  }
}
